import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=21b27b4a&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b27b4a",
  null
  
)

export default component.exports